module.exports = __webpack_public_path__ + "img/bg.52019bbe.png";